import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setAccess(data.access);
    } catch (e) {
      setUser(null);
      setAccess(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
    const fallback = setTimeout(() => setLoading(false), 7000);
    return () => clearTimeout(fallback);
  }, [checkAuth]);

  const setAuth = (u, a) => { setUser(u); setAccess(a); setLoading(false); };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("docket_token");
    setUser(null);
    setAccess(null);
  };

  return (
    <AuthContext.Provider value={{ user, access, loading, checkAuth, setAuth, logout, setUser, setAccess }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
